(ns pfo.assignment.component
  (:require [promesa.core :as p]
            [pfo.util :as util :refer [handler set-page entity reset-from-event classes]]
            [pfo.state :as state]
            [reagent.core :as reagent :refer [atom] :refer-macros [with-let]]
            [pfo.collection.model :as collection-model]
            [pfo.widget.paginator :refer [paginator load-more tfoot-paginator]]
            [pfo.widget.list :refer [orderer]]
            [pfo.widget.tree :refer [tree-view]]
            [pfo.category.model :as category-model]
            [pfo.form :as form]
            [pfo.widget.modal :refer [modal]]
            [pfo.api :refer [process-error]]
            [pfo.widget.autocomplete :refer [react-select-styles]]
            ["react-select" :default Select :refer (components)]
            ["react-select/async" :default Async]
            [clojure.string :as str]))

(declare assignments-edit-modal assignments-add-new-notable nav-search get-collection-ids get-collection-ids-set)

(def assignment-min-num-collaspe 3)

(def SingleValue (.-SingleValue components))
(def Option (.-Option components))

(def collection-name collection-model/collection-name)

(defn group-chooser [groups value-atom]
  [:select {:value @value-atom :on-change (reset-from-event value-atom)}
   (doall
     (for [group groups]
       [:option  {:key (:id group) :value (:id group)}
        (util/add-inactive-to-name group)]))])

(defn get-initial-ui-assignments [obj-assignments]
  "Converts a list of obj-assignments (e.g. document_collections) to a list of assignment objects
  used in the UI. If obj is nil, returns a list with a single empty assignment."
  (if obj-assignments
    (mapv (fn [dc] {:collection (str (:collection_id dc))
                    :collection-obj (collection-model/to-search-obj (:collection dc))
                    :main (:main dc)}) obj-assignments)
    [{:collection-obj (collection-model/to-search-obj nil)}]))

(defn set-assignment [assignments index assignment-map]
  (let [assignment (nth assignments index)]
    (assoc assignments index assignment-map)))

(defn assignments-to-id-set [assignments]
  (into #{} (for [{:keys [collection]} assignments
                  :when collection] (js/parseInt collection))))

(defn assignments-edit-notable-redesign [options
                                         assignments
                                         errors
                                         initial-collection
                                         assignments-to-delete
                                         group-id
                                         primary-collection-id-global]
  (let [categories (atom [])]

    (add-watch group-id :assinments-edit-notable-group-id
               (fn [& args]
                 (reset! assignments (get-initial-ui-assignments nil))
                 (reset! primary-collection-id-global nil)))
    (when initial-collection
          (do
            (swap! assignments set-assignment 0
                   {:collection     (str (:id initial-collection))
                    :collection-obj (collection-model/to-search-obj initial-collection)})))

    (fn
      [options
       assignments
       errors
       initial-collection
       assignments-to-delete
       group-id
       primary-collection-id-global]
      (let [disabled-ids (assignments-to-id-set @assignments)]
        [:section
         (into
          [:div]
          (map-indexed
           (fn [index assignment]

             (list*
              [(when (:collection-label options) (:collection-label options))
               [:div.c-assignment-item-edit.redesign
                {:key index}
                (when (zero? index)
                  [:span
                   [:span.error (:assignment @errors "")]
                   [:span.error (:collection_id @errors "")]])

                 (let [is-primary (and (some? @primary-collection-id-global)
                                       (= @primary-collection-id-global (:collection assignment)))]
                   [:div
                    [:div.c-assignment-item-edit__collection-with-primary.o-margin-elements--medium
                     {:class (if is-primary "is_primary" "")}

                     (when (> (count @assignments) 1)
                           [:button.c-assignment-item-edit__assignment-remove._h.c-round-button
                            {:on-click (util/handler
                                        (fn []
                                          (let [assignment-to-delete (get @assignments index)]
                                            (swap! assignments util/vec-remove index)
                                            (when (:collection assignment-to-delete)
                                              (swap! assignments-to-delete conj (util/str->int (:collection assignment-to-delete))))
                                            (when (:main assignment-to-delete)
                                                  (let [first-assignment (first @assignments)]
                                                    (swap! assignments set-assignment 0 (merge first-assignment {:main true}))
                                                    (reset! primary-collection-id-global (:collection first-assignment)))))))}
                            [:span "×"]])

                     [nav-search
                      {:on-change        (fn [e action-type]
                                           (let [has-primary-assignment?             (some? @primary-collection-id-global)
                                                 {:keys [value label ancestorNames]} (-> (js->clj e :keywordize-keys true))
                                                 assignment                          {:collection     value
                                                                                      :collection-obj {:value value :label label :ancestorNames ancestorNames}
                                                                                      :main           (not has-primary-assignment?)}]

                                             (swap! assignments set-assignment index assignment)
                                             (swap! assignments-to-delete
                                                    (fn [old-assignments-to-delete assignment]
                                                      (set (remove #(= % (:collection assignment)) old-assignments-to-delete) ))
                                                    assignment)
                                             (when-not has-primary-assignment?
                                                   (reset! primary-collection-id-global value))

                                             ;; add empty assignment at the end of list which allow next search.
                                             ;; Conditional prevents from adding empty collection when there is one already
                                             (when-not (some empty? @assignments)
                                                       (swap! assignments conj {}))))

                       ;; value must be either null (nil) or undefined to display placeholder
                       ;; https://github.com/JedWatson/react-select/issues/1043
                       :value            (when (-> assignment :collection-obj :value) (:collection-obj assignment))
                       :placeholder      "Type collection name"
                       :parent-id        @group-id
                       :disabled-ids     disabled-ids
                       :include-inactive @(:include-inactive-atom options)}]

                     ;;Show "primary" checkbox only on valid assignments (i.e non-empty)
                     (when (get-in assignment [:collection-obj :value])
                           [:div.u-flex
                            [:input
                             {:on-click (fn [ev]
                                          (when (form/checked? ev)
                                                (reset! primary-collection-id-global (:collection assignment))
                                                (swap! assignments
                                                       (fn [assignments]
                                                         (mapv
                                                          (fn [assignment]
                                                            (merge assignment
                                                                   {:main (= @primary-collection-id-global (:collection assignment))}))
                                                          assignments)))))
                              :type     :checkbox
                              :checked  is-primary}]
                            [:label.u-nowrap " Primary"]])]
                    (when
                      (= (:collection assignment)
                         (str (get-in @errors [:__meta__ :assignment :collection_id])))
                      (get-in @errors [:__meta__ :assignment :error-extra-component]))])]]))
           @assignments))

         [assignments-edit-modal
          assignments
          group-id
          primary-collection-id-global
          {:assignments-to-delete assignments-to-delete
           :include-inactive-atom (:include-inactive-atom options)}]
         [assignments-add-new-notable assignments]]))))

(defn assignments-add-new [assignments]
  ;; Only allow adding new set when collection in the last one is chosen
  [:tbody
   (when (seq (:collection (last @assignments)))
     [:tr
      [:td " "]
      [:td [:button {:on-click (util/handler (fn [] (swap! assignments conj {})))}
            "Assign another collection"]]])])

(defn assignments-add-new-notable [assignments]
  ;; Only allow adding new set when collection in the last one is chosen
  (when (:collection (last @assignments))
    [:button.c-round-button  {:on-click (util/handler (fn [] (swap! assignments conj {})))} "+"]))

(defn collection-field-header
  ([include-inactive-atom label]
   [:dt [:span.o-space-between [:span label]
         [:label [:input (form/set-checked @include-inactive-atom
                                           {:on-change (util/handler #(swap! include-inactive-atom not))})] "Include inactive"]]])
  ([include-inactive-atom] (collection-field-header include-inactive-atom "Collection")))

(defn assignments-edit-modal [assignments group-id primary-collection-id-global options]
  (with-let [collection-tree (atom {})
             load-collection-tree (fn []
                                    (->> (collection-model/collection-tree @group-id true @(:include-inactive-atom options) (:filter-options options))
                                      (p/map (fn [response] (reset! collection-tree response)))
                                      (process-error)))
             _ (load-collection-tree)

             _ (add-watch group-id :assignments-edit-notable-group-id (fn [& args]
                                                                        (load-collection-tree)
                                                                        (reset! assignments (get-initial-ui-assignments nil))
                                                                        (reset! primary-collection-id-global nil)))

             _ (add-watch (:include-inactive-atom options) :assignments-edit-notable-include-inactive
                 (fn [& args]
                   (load-collection-tree)))]

      ;; Only allow adding new set when collection in the last one is chosen
      (let [open-modal (fn []
                             (let [refs (seq (get-in options [:filter-options :collection_template_ref]))
                                  ref-set (set refs)]
                              (reset!
                                state/collection-tree-modal
                                {:enabled true
                                 :cb (fn [collection]
                                       (if-let [cb (:cb options)]
                                         (cb collection)
                                         (->> (collection-model/collection-ancestors (:id collection))
                                           (p/map (fn [ancestors]
                                                    (let [collection (assoc collection :ancestors ancestors)]
                                                      (swap! state/collection-tree-modal
                                                        (fn [collection-tree-modal]
                                                          (assoc collection-tree-modal
                                                            :choosen-assignments (conj (:choosen-assignments collection-tree-modal)
                                                                                   {:collection (str (:id collection))
                                                                                    :collection-obj (collection-model/to-search-obj collection)
                                                                                    :main (not @primary-collection-id-global)})
                                                            :disabled-ids (conj (:disabled-ids collection-tree-modal) (:id collection))
                                                            :enabled true)))

                                                      (when-not @primary-collection-id-global
                                                        (reset! primary-collection-id-global (str (:id collection))))))))))

                                 :tree-items collection-tree
                                 :disabled-ids (assignments-to-id-set @assignments)
                                 ;;filter out first,empty collection in assignments
                                 :choosen-assignments (set  (filterv (fn [assignment] (contains? assignment :collection) ) @assignments) )
                                 :group-id @group-id
                                 ;;set assignments edited in modal to collection form
                                 :on-save-cb (fn [_]
                                               (let [assignments-to-delete (:assignments-to-delete options)]
                                                 (when assignments-to-delete
                                                   (swap! (:assignments-to-delete options) clojure.set/union
                                                     (clojure.set/difference
                                                       (get-collection-ids-set @assignments ) (get-collection-ids-set (:choosen-assignments @state/collection-tree-modal)))))

                                                 (reset! assignments (into [] (:choosen-assignments @state/collection-tree-modal)))
                                                 (some-> (:save-cb options) (apply [(into [] (:choosen-assignments @state/collection-tree-modal))]))
                                                 (when assignments-to-delete
                                                   (swap! (:assignments-to-delete options) clojure.set/difference
                                                     (get-collection-ids-set @assignments)))

                                                 ;;add empty assignment at the end of list which allow next search
                                                 (swap! assignments conj {})

                                                 (swap! state/collection-tree-modal assoc :enabled false)))

                                 :primary-collection-id primary-collection-id-global
                                        ; TODO temporary flag
                                 :include-inactive-atom (:include-inactive-atom options)
                                 :options (merge
                                            options
                                            {:search-filter-fn (fn [entry]
                                                                 (if (seq refs)
                                                                   (contains? ref-set (get-in entry [:collection_type :ref]))
                                                                   true))})})))]
        (when-let [expose-open-fn (:expose-open-fn options)]
          (reset! expose-open-fn open-modal))
        [:button.c-assignments-edit-button._h
         {:class (:bt-class options)
          :on-click (handler open-modal)}
         (or (:select-from-tree-label options) "Select from the Collection Tree")])
    (finally
      ;; A stale open-modal closure would open the modal with a collection tree
      ;; that is no longer refreshed after this component unmounts.
      (some-> (:expose-open-fn options) (reset! nil))
      (remove-watch group-id :assignments-edit-notable-group-id)
      (remove-watch (:include-inactive-atom options) :assignments-edit-notable-include-inactive))))

(defn assignments-table [assignments]
  [:dd (when (seq assignments)
         (for [assignment assignments]
           [:span {:key (:collection_id assignment)} [:a {:href (str "#/collection/details/" (:collection_id assignment))}
                   (get-in assignment [:collection :name])] [:br]]))])

(defn assignment-list
  ([options assignments]
   (let [num-assignments (count assignments)
         collapsable (> num-assignments assignment-min-num-collaspe)
         collapsed (atom (identity collapsable))]
     (fn [& _]
       [:ul.c-assignment-list
        (let [sorted-assignments (sort (fn [a1 a2]
                                         (compare
                                           [(:main a2) (str/join "/" (map :name (get-in a1 [:collection :ancestors])))]
                                           [(:main a1) (str/join "/" (map :name (get-in a2 [:collection :ancestors])))]))
                                   assignments)]
          (doall
            (for [[index assignment] (map-indexed vector (if @collapsed
                                                           (take 1 sorted-assignments)
                                                           sorted-assignments))]
              [:li {:key (:collection_id assignment) :class (when (:main assignment) "c-assignment-list__main
                                                                               o-collapsable__persist--item")}
               [:span.c-assignment-list__ancestors
                (doall
                  (for [ancestor (butlast (get-in assignment [:collection :ancestors]))]
                    [:span {:key (:id ancestor)
                            :class (if (:main assignment) "primary" "")} (if (:has_any_permission ancestor)
                                                                           [:a {:href (str "#/collection/details/" (:id ancestor))} (collection-name ancestor)]
                                                                           (collection-name ancestor)) " / "]))]
               (when-not (:hide-path-leaf options)
                 [:span.c-assignment-list__collection
                  [:a {:href (str "#/collection/details/" (:collection_id assignment))} (collection-name (:collection assignment))]])

               (let [collection-type (:collection_type (last (get-in assignment [:collection :ancestors]))) ]
                 [:div.u-flex.o-flex-align--space-between
                  (when collection-type
                    [:div.c-assignment-list__assets.u-flex__self-align-center (get-in collection-type [:asset_type :name]) ": " (:name collection-type)])
                  (when (and collapsable (or @collapsed (= num-assignments (inc index))))
                    [:button.u-flex__self-align-center.u-margin-left
                     {:on-click #(swap! collapsed not)}
                     (if @collapsed
                       [:span "View " num-assignments " Collections"]
                       "Hide Collections")])])])))])))
  ([assignments] (assignment-list nil assignments)))

(defn assignment-list-with-header [options assignments]
  (let [collapsed? (atom false)
        show-expander? (and (not (:hide-expander options)) (> (count assignments) 1))]

    (fn [options assignments]
      [:div.o-collapsable.o-collapsable__persist {:class (when @collapsed? "is-collapsed")}
       [:h4.c-heading--no-top-border (or (:label options) "For:")
        (when show-expander?
          [:a.o-collapsable__expander {:on-click #(swap! collapsed? not)}])]
       [assignment-list assignments]])))

(defn get-collection-ids
  "Returns non-nil collection-ids corresponding to given assignment list"
  [assignments]
  (filterv identity (mapv (fn [assignment] (:collection assignment)) assignments)))

(defn get-collection-ids-set
  "Returns non-nil collection-ids set corresponding to given assignment list"
  [assignments]
  (set
    (filter identity
            (mapv (fn [assignment] (util/str->int (:collection assignment)))
                  (filter (fn [assignment] (:collection assignment)) assignments)))))

(defn collection-list [options collection-ids]
  (let [collections (atom nil)
        order (atom "name")
        current-page (atom 1)
        load-collections (fn [page]
                           (->> (collection-model/sortable-collection-list collection-ids page @order)
         (p/map (fn [%] (reset! collections %) (reset! current-page page)))
         (process-error)))]

    (load-collections 1)
    (add-watch order :changed-order (fn [_ _ _ newstate] (load-collections @current-page)))
    (fn [options collection-ids]
      [:div
       (if (seq (:results @collections))
             [:table.t-table-redesign
              [:thead
               [:tr
                [:th.no-padding (orderer order "Path" "path_info")]
                [:th.no-padding (orderer order "Name" "name")]]]
              [:tbody
               (doall
                 (for [collection (:results @collections)]
                   [:tr {:key (:id collection)}
                    [:td.assignments [assignment-list {:hide-path-leaf false}
                                      [(assoc collection
                                              :collection (assoc collection :ancestors (identity (:ancestors collection)))
                                              :collection_id (:id collection)
                                              :main true)]]]
                    [:td.name (:name collection)]]))]

              [tfoot-paginator

               [paginator
                (map (fn [page-number]
                       {:number page-number
                        :on-click (util/handler (fn [] (load-collections page-number)))})
                     (:page_numbers @collections))
                @current-page
                (when (:has_previous @collections) (util/handler #(load-collections (- @current-page 1))))
                (when (:has_next @collections) (util/handler #(load-collections (+ @current-page 1))))]
               2
               (-> (:page_numbers @collections) count (> 1))]]
             [:p.o-media--bottom-shadow "No collections."])])))

(defn select-option [props]
  (let [list-label (get-in (js->clj props) [:data "listLabel"])]
    [:> Option (if list-label
                         (assoc props :children (reagent/as-element list-label))
                         props)]))

(defn single-value [props]
  (let [data (:data (js->clj props))
        ancestors-to-display (butlast (rest (data "ancestorNames")))]
    [:> SingleValue (assoc props :children (reagent/as-element [:span (doall (for [anc ancestors-to-display] [:span anc " / "])) [:b (data "label")]]))]))

(defn nav-search [options]
  [:> Async
   (merge
     {:class "u-full-width"
      :classNamePrefix "nav-search"
      :components {:Option (reagent/reactify-component select-option)
                   :SingleValue (reagent/reactify-component single-value)}
      :loadOptions (partial collection-model/collection-search (:parent-id options) (:disabled-ids options) (:include-inactive options) (:filter-fn options))}
     (or options {})
     (:primary react-select-styles))])

(defn tree [options tree-item disabled-ids]
  (let [on-click-cb (:on-click-cb options)
        item-id (get-in tree-item [:item_data :id])
        default-collapsed (:default-collapsed options)
        expand-root (:expand-root options)
        collapsed (:collapsed options)]

    (if-let [item-data (:item_data tree-item)]
      (let [is-current (= (str item-id) (str (:current-id options)))
            is-inactive (not (:active item-data))
            is-collapsed (fn [item-id] (if is-current false (get @collapsed item-id @default-collapsed)))
            ;; Selected nodes and filter-unmatched ancestors both render as plain
            ;; spans, but only selected ones are bold.
            is-selected (or (contains? disabled-ids (:id item-data))
                            (contains? (:disabled-ids @state/collection-tree-modal) (:id item-data)))
            options (dissoc options :expand-root)]
        ^{:key item-id}
        [tree-view {:nodeLabel (if-not (or is-selected
                                           (and (contains? item-data :matched ) (not (:matched item-data))))
                                 (reagent/create-element
                                   "a" #js{:onClick (fn [e] (on-click-cb item-data)
                                                      (.preventDefault e))
                                           :href "#"
                                           :className (str
                                                        (when is-current "current ")
                                                        (when is-inactive "inactive "))}
                                   (:name item-data))

                                 (reagent/create-element
                                   "span" #js{:className (when is-selected "is-selected")}
                                   (:name item-data)))

                    :collapsed (if-not (nil? expand-root)
                                 (not expand-root)
                                 (is-collapsed item-id))
                    :on-click (util/handler (fn [] (swap! collapsed assoc item-id (not (is-collapsed item-id)))))}

         (let [grouped-subitems (group-by (fn [subitem] (get-in subitem [:item_data :collection_type :asset_type :name])) (:subitems tree-item))
               grouped-subitems-sorted (sort-by (fn [subitem] (-> subitem second first :item_data :collection_type :ordering)) grouped-subitems)]

           (doall
             (for [[asset-type-name subitems] grouped-subitems-sorted]
               ^{:key asset-type-name} [:div [:h5 (str asset-type-name)]
                                        (doall (for [subitem subitems]
                                                 (if (seq (:subitems subitem))
                                                   (tree options subitem disabled-ids)
                                                   (let [item-id (get-in subitem [:item_data :id])
                                                         item-data (:item_data subitem)]
                                                     (reagent/create-element

                                                       "div" #js{:className
                                                                 (str "tree-view__leaf " (when (or
                                                                                                 (contains? disabled-ids (:id item-data))
                                                                                                 (contains? (:disabled-ids @state/collection-tree-modal) (:id item-data))) "is-selected"))
                                                                 :key (:id item-data)}
                                                       (if-not (or (contains? disabled-ids (:id item-data))
                                                                   (contains? (:disabled-ids @state/collection-tree-modal) (:id item-data)))

                                                         (reagent/create-element
                                                           "a" #js{:onClick (fn [e] (on-click-cb item-data)
                                                                              (.preventDefault e))
                                                                   :href "#"
                                                                   :className (str
                                                                                (when (= (str item-id) (str (:current-id options))) "current ")
                                                                                (when (not (:active item-data)) "inactive "))
                                                                   :key (:id item-data)}
                                                           (:name item-data))
                                                         (:name item-data)))))))])))])
      ;;TODO also add grouping items
      [:div {:key (str "tree-" item-id)}
       (doall (for [subitem (:subitems tree-item)]
                ^{:key (:id subitem)} (tree options subitem disabled-ids)))])))

(defn- get-label [obj]
   (or (not-empty (:plainLabel obj)) (:label obj)))

(defn collection-tree [tree-items on-click-cb current-id disabled-ids on-save-cb group-id primary-collection-id-atom include-inactive-atom options]
  (let [default-collapsed (atom true)
        collapsed (atom {})]

    (reagent/create-class
      {:reagent-render
       (fn []
         (let [choosen-assignments (:choosen-assignments @state/collection-tree-modal)]
           [:div.collection-tree.redesign
            [:header
             [:h3.collection-name (get-in @tree-items [:subitems 0 :item_data :name])]
             [:h5.u-margin-bottom--xs [:span.o-space-between "Select or search for the collection" [:label [:input (form/set-checked @include-inactive-atom
                                                                                                                                     {:on-change (util/handler #(swap! include-inactive-atom not))})] "Include inactive"]]]
             [:section
              [nav-search
               {:value (map
                         (fn [assignment]
                           (assoc
                             (:collection-obj assignment)
                             :label (get-label (:collection-obj assignment))
                             :plainLabel (get-label (:collection-obj assignment))))
                         choosen-assignments)
                :on-change (fn [e action-type]
                             (let [assignments (-> (js->clj e :keywordize-keys true))
                                   assignments (if (:single-choice options)
                                                 [assignments]
                                                 assignments)
                                   choosen-assignments (map (fn [assignment] {:collection (str (:value assignment))
                                                                              :collection-obj (assoc assignment
                                                                                                :label (get-label assignment)
                                                                                                :plainLabel (get-label assignment))
                                                                              :main (some-> primary-collection-id-atom deref (= (str (:value assignment))))}) assignments)
                                   disabled-ids (-> (map (fn [assignment] (:value assignment)) assignments) set)]

                               (swap! state/collection-tree-modal assoc
                                 :choosen-assignments choosen-assignments
                                 :disabled-ids disabled-ids)))

                :placeholder "Type collection name"
                :parent-id group-id
                :disabled-ids (:disabled-ids @state/collection-tree-modal)
                :filter-fn (:search-filter-fn options)
                :isMulti (not (:single-choice options))}]

              [:button.u-margin-left--xs {:on-click on-save-cb} "Save"]]]

            (tree {:on-click-cb on-click-cb
                   :current-id current-id
                   :default-collapsed default-collapsed
                   :collapsed collapsed
                   :expand-root true} @tree-items (:disabled-ids @state/collection-tree-modal) )]))
       :component-did-mount (fn [_]
                              (when-let [current-item (first (array-seq (.getElementsByClassName js/document "current")))]
                                (let [current-offset (.-offsetTop current-item)]
                                  (.scrollTop (js/$ ".modal-inner") (- current-offset 30)))))})))

(defn collection-tree-modal []
  [modal [collection-tree
          (:tree-items @state/collection-tree-modal)
          (:cb @state/collection-tree-modal)
          (:current-id @state/collection-tree-modal)
          (:disabled-ids @state/collection-tree-modal)
          (:on-save-cb @state/collection-tree-modal)
          (:group-id @state/collection-tree-modal)
          (:primary-collection-id @state/collection-tree-modal)
          (:include-inactive-atom @state/collection-tree-modal)
          (:options @state/collection-tree-modal)
          ] state/collection-tree-modal])
